import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/feven_move.svg'
import _imports_1 from '@/assets/img/menu_right.svg'
import _imports_2 from '@/assets/img/hexagon.svg'


const _withScopeId = n => (_pushScopeId("data-v-42ab61f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finder" }
const _hoisted_2 = {
  key: 0,
  class: "noMatches page_padding text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mb-5",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "btn fev_button bg_brand refuseButton mt-5" }
const _hoisted_5 = {
  key: 1,
  class: "match_container position-relative"
}
const _hoisted_6 = {
  class: "lottieAnimation",
  ref: "lottieExperience"
}
const _hoisted_7 = { class: "page_padding pb-0" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_9 = { class: "hexagonContainer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_11 = { class: "percentageContainer" }
const _hoisted_12 = { class: "amount" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol" }, "%", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradientOverlay" }, null, -1))
const _hoisted_15 = { class: "question" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_chevron_fixed = _resolveComponent("chevron-fixed")!
  const _component_person_info = _resolveComponent("person-info")!
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")!
  const _component_report_question = _resolveComponent("report-question")!
  const _component_full_horizontal_scroll = _resolveComponent("full-horizontal-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.match)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_localized_text, {
            localizedKey: "app_NessunProfiloInQuestArea",
            text: "Nessun profilo<br /> in quest'area",
            class: "fev_text1 fw_800 text-uppercase"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "app_TiRicordiamoCheSeNonTroviProfiliNellaTuaZonaPuoiCambiareLaTuaPosizioneUtilizzandoFevenMoveAllInternoDeiFiltriDiRicerca",
            text: "Ti ricordiamo che se non trovi profili nella tua zona puoi cambiare la tua posizione utilizzando Feven Move all’interno dei filtri di ricerca.",
            class: "fev_text5 mt-2 d-block"
          }),
          _createElementVNode("button", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_CambiaPosizione",
              text: "Cambia Posizione",
              class: "text-uppercase"
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.match.biography)
            ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                key: 0,
                vertical: "top",
                horizontal: "right",
                class: _normalizeClass(["whiteRightBg pointer", {op_5 : !_ctx.match.biography}])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openDescription')))
                  })
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.match.hasAnyExperience)
            ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                key: 1,
                vertical: "top",
                horizontal: "right",
                class: _normalizeClass(["whiteRightBg pointer", { 'marginTopFromOtherChevronFixed' : _ctx.match.biography }])
              }, {
                default: _withCtx(() => [
                  (_ctx.match.biography)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "invisible_div",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('openDescription')), ["stop","prevent"]))
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "lottieContainer bg_experience",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openExperienceList')))
                  }, [
                    _createElementVNode("div", _hoisted_6, null, 512)
                  ])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_person_info, {
              class: "text_underlined pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(_ctx.match.appUserIdentifier))),
              name: _ctx.match.personName,
              birthDate: _ctx.match.birthDate,
              distanceMeters: _ctx.match.distanceMeters,
              sexualOrientation: _ctx.match.sexualOrientation,
              left: true
            }, null, 8, ["name", "birthDate", "distanceMeters", "sexualOrientation"]),
            _createElementVNode("div", {
              class: _normalizeClass(["otherMatchResultContainer", _ctx.match.affinityRateReachedFromOther != null ? 'hasOtherMatchCompleted' : ''])
            }, [
              (_ctx.match.affinityRateReachedFromOther != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.match.affinityRateReachedFromOther), 1),
                        _hoisted_13
                      ])
                    ]),
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_{{Name}}HaRaggiuntoIlTuoAffinityRate",
                      text: "{{Name}} ha raggiunto il tuo Affinity Rate!",
                      object: { Name: _ctx.$filters.cutNameTooLong(_ctx.match.personName) },
                      class: "fev_text6"
                    }, null, 8, ["object"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.match.minimumAffinityRate > 0)
                ? (_openBlock(), _createBlock(_component_love_face_shadow_bar, {
                    key: 1,
                    text: _ctx.affinityRateText
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["card_container", _ctx.match.affinityRateReachedFromOther != null ? 'hasOtherMatchCompleted' : ''])
          }, [
            _createVNode(_component_full_horizontal_scroll, { class: "px-4 py-0" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.questions, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "imageCardContainer bg_blue",
                    key: index,
                    style: _normalizeStyle('background-image: url(\'' + question.blurredImageUrl + '\')')
                  }, [
                    _hoisted_14,
                    _createVNode(_component_report_question, {
                      matchIdentifier: _ctx.match.matchIdentifier,
                      questionIndex: index,
                      appUserIdentifier: _ctx.match.appUserIdentifier
                    }, null, 8, ["matchIdentifier", "questionIndex", "appUserIdentifier"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(question.question), 1)
                    ])
                  ], 4))
                }), 128))
              ]),
              _: 1
            })
          ], 2)
        ]))
  ]))
}